exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dropzone[data-v-079f3100] {\n  background-color: #eee;\n  border: 1px solid #aaa;\n  border-radius: .2rem;\n}\n.new-footer[data-v-079f3100] {\n  background-color: white;\n}\n.preferred-method[data-v-079f3100] {\n  margin-left: 90%;\n  border-radius: 50%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-079f3100","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/templates/New.vue
// module id = 1086
// module chunks = 2